import * as React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PlatformProvider } from "@omni/client-platform";
import { AuthProvider } from "@/auth/useAuth";
import { ThemeProvider } from "@/app/theme";
import { ControlsProvider } from "@/hooks/useControls";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <PlatformProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ControlsProvider>{children}</ControlsProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </PlatformProvider>
  );
}
